module.exports = __webpack_public_path__ + "img/组 31.a3a9eae4.png";